import { CaretDownOutlined } from '@ant-design/icons';
import useMobileView from '@design-system/hooks/useMobileView';
import { Dropdown } from 'antd';
import { MenuItem } from '@source/interface';
import { useRouter } from 'next/router';
import { FC, PropsWithChildren, useState } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

const StyledDropdownTrigger = styled.div<{ $isActive?: boolean; $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$isActive || props.$isOpen ? props.theme.color.primaryBase : props.theme.color.onBackgroundHighEmphasis};
  ${(props) => props.theme.typo.style.mainButtonOrLink}
  ${(props) => props.theme.typo.familyGoogle.semiBold};
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.color.primaryBase};
  }
`;

const StyledIcon = styled(CaretDownOutlined)<{ $isOpen?: boolean }>`
  margin-top: 2px;
  margin-left: 4px;
  transition: transform 0.3s ease;
  ${(props) => props.theme.typo.style.captionRegular};
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

interface IDropdownMenuProps extends PropsWithChildren {
  item: MenuItem;
}

const DropdownMenu: FC<IDropdownMenuProps> = ({ item, children }) => {
  const router = useRouter();
  const isMobile = useMobileView(768);
  const [isOpen, setIsOpen] = useState(false);

  const { pathname } = router;
  const isActiveLink = pathname === item.pathName;

  return (
    <Dropdown
      dropdownRender={() => children}
      trigger={isMobile ? ['click'] : ['hover']}
      placement={isMobile ? 'bottomCenter' : 'bottomLeft'}
      onOpenChange={setIsOpen}
      open={isOpen}
      overlayStyle={{ paddingTop: 5 }}
    >
      <StyledDropdownTrigger $isActive={isActiveLink} $isOpen={isOpen}>
        <Trans defaults={item.titleTranslate} />
        <StyledIcon $isOpen={isOpen} />
      </StyledDropdownTrigger>
    </Dropdown>
  );
};

export default DropdownMenu;
